
// Func = limiting Scope for this file
var lastScrollTop = 0;

if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

const HEADER_LOGO = document.getElementById('jsLogo');

(function(){

    let itemsMenu = document.querySelectorAll('.privary-navigation .privary-navigation__item');
	itemsMenu.forEach((itemMenu)=>{
		if(itemMenu.querySelector('.submenu')){
			itemMenu.addEventListener('mouseenter',()=>{
				itemMenu.classList.add('hover');
				itemMenu.querySelector('.submenu').classList.add('show');
			});
			itemMenu.addEventListener('mouseleave',()=>{
				itemMenu.classList.remove('hover');
				itemMenu.querySelector('.submenu').classList.remove('show');
			})
		}
	})

    window.onload = function() {
		scrollW();
		window.addEventListener('scroll', function(){
			scrollW();
		})
			
	if (window.location.href.indexOf('/menus#blog-10175') !== -1) {
		window.scrollBy({ top: -150, left: 0, behavior: "smooth" });
	}
	};

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	// Navigation
	if(window.innerWidth > 640){
		let primaryNavi = document.getElementById('primary-nav');
		let primaryNav = document.getElementById('privary-navigation');
		let firstNav = document.getElementById('firstHalft_nav');
		let lastNav = document.getElementById('lastHalft_nav');
		// Divide the Primary Nav elements
		let primaryNavLi = primaryNav.children;	
	
		let NavLiArray = Array.from(primaryNavLi);
		// console.log(NavLiArray);
		let splitNav = Math.round(NavLiArray.length / 2);
		let firstHalftElements = NavLiArray.slice(0, splitNav);
		let lastHalftElements = NavLiArray.slice(splitNav);
		
		// It add the corresponding 'li' elements 
		firstNav && firstHalftElements.forEach(element => { firstNav.append(element);} );
		lastNav && lastHalftElements.forEach(element => { lastNav.append(element); });

		primaryNavi.remove();
	}
	//

	// PARTNERS
	

	if(document.getElementById("partners_block-text") ) {
		let partnersContents = document.querySelectorAll(".partners_block__item");
		partnersContents.forEach(ele => {
			ele.addEventListener("mouseover", () => {
				ele.querySelector("#partners_block-text").classList.remove("hidden");
			});
		});
		partnersContents.forEach(ele => {
			ele.addEventListener("mouseout", () => {
				ele.querySelector("#partners_block-text").classList.add("hidden");
			});
		});
	}
		/* Lightbox Gallerys */
		const customLightbox = new LBX('.js-lbx-gallery', {
			customClass:'lbx-gallery',
		});


			// --------- Navigation Triggers ---------

	let openMenu = document.getElementById("burgerMenu");
	if( openMenu ){
		openMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.add("active");
		});
	}


	let closeMenu = document.querySelector(".close-menu");
	if(closeMenu){
		closeMenu.addEventListener("click", function() {
		document.querySelector(".js-navigation").classList.remove("active");
		});
	}

	let itemsClose = document.querySelectorAll(".js-navigation .navigation .inner ul li");
	if(itemsClose) {
		itemsClose.forEach( e => {
			e.addEventListener("click", () => {
				document.querySelector(".js-navigation").classList.remove("active");
			})
		});
	}

	let footerForm = document.querySelector('.footer form');
	let allInputsFooterForm = footerForm.querySelectorAll('.field.input');
	allInputsFooterForm.forEach( divInput => {
		divInput.querySelector('input, textarea').addEventListener( 'click', () => {
			divInput.classList.add('clicked')
		} );
	});

	let allForms = document.querySelectorAll('form');
	allForms.forEach( form => {
		let allContainerInput = form.querySelectorAll('.form-module__field');
		allContainerInput.forEach( divInput => {
			divInput.querySelector('input, textarea').addEventListener( 'click', () => {
				divInput.classList.add('clicked')
			} );
		} );
	});

	if(document.querySelector('#form_id-219 button')) {
		let bottonForm = document.querySelector('#form_id-219 button');
		console.log(bottonForm);
		bottonForm.classList.remove("btn");
		bottonForm.classList.add("btn-form");




	}

})();

function scrollW(){
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	if(st > 80){
		if (st > lastScrollTop){
			// downscroll code
			if(!document.getElementById('header').classList.contains('down')){
				document.getElementById('header').classList.add('down');
				document.getElementById('header').classList.remove('up');
				let altLogo = HEADER_LOGO.dataset.alt;
				let sourceLogo = HEADER_LOGO.getAttribute('src');
				changeLogo(altLogo,sourceLogo)
			}
		} else {
			// upscroll code
			if(!document.getElementById('header').classList.contains('up')){
				document.getElementById('header').classList.add('up');
				document.getElementById('header').classList.remove('down');
				let altLogo = HEADER_LOGO.dataset.alt;
				let sourceLogo = HEADER_LOGO.getAttribute('src');
				changeLogo(altLogo,sourceLogo)
			}
		}
	} else {
		if(document.getElementById('header').classList.contains('up') || document.getElementById('header').classList.contains('down')){
			document.getElementById('header').classList.remove('up');
			document.getElementById('header').classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}

function changeLogo(src,alt) {
	HEADER_LOGO.setAttribute('src',src);
	HEADER_LOGO.setAttribute('data-alt',alt);
}